export default "__VITE_ASSET__CIDZk9UI__"